import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap'
import PageTooltip from "./Tooltip"
import Time from './Time'

const questionShowHide = (conditions, questions) => {
    var show = true
    if (conditions !== null) {
        show = !conditions.show
        var checkQuestion = questions.find((data) => data.id == conditions.question)
        if (checkQuestion.user_answers === null || checkQuestion.user_answers === "") {
            return false
        }
        if (checkQuestion.type === "radio") {
            var checkAnswer = checkQuestion.answers.find((data) => data.id == checkQuestion.user_answers)
            if (checkAnswer.description.toLowerCase() == conditions.answers[0].toLowerCase()) {
                show = !show
            }
        } else if (checkQuestion.type === "text" || checkQuestion.type === "number") {
            for (let i = 0; i < conditions.answers.length; i++) {
                if (conditions.answers[i] == checkQuestion.user_answers) {
                    show = !show
                }
            }
        } else if (checkQuestion.type === "dropdown") {
            var checkAnswer = checkQuestion.answers.find((data) => data.id == checkQuestion.user_answers)
            if (checkAnswer.description == conditions.answers[0]) {
                show = !show
            }
        }
    }
    return show
}

const getDivisionQuestions = (data) => {
    var divisions = null
    if (data.user_answers != null && data.answers.length > 0) {
        var answer = data.answers.find((q) => q.id == parseInt(data.user_answers))
        if (answer.divisions != undefined && answer.divisions.length>0) {
            divisions = answer.divisions
        }
    }
    return divisions
}

function Questionnaire(props) {

    return (
        <Fragment>
            {props.parentIndex + 1 === props.start ? <span>{props.data.description}</span> : null}
            {props.parentIndex + 1 === props.start || props.allShow ?
                props.data.questions.map((question, childIndex) => {
                    if (!questionShowHide(question.conditions, props.data.questions)) { return null }
                    return <>
                        <div key={question.id} className='onboarding-single-question'>
                            <div className='question-style'>
                                {question.hint !== undefined && question.hint !== null ? <PageTooltip
                                    title={question.description}
                                    text={question.hint}
                                /> : question.description}
                            </div>
                            {question.type === "radio" ?
                                <div className='answer-style-radio' key={`inline-radio`}>
                                    {question.answers.map((answer) => {
                                        return <Form.Check
                                            key={answer.id}
                                            label={answer.description}
                                            name={`group${question.id}`}
                                            type="radio"
                                            id={`question-${question.id}-answer-${answer.id}`}
                                            checked={question.user_answers === answer.id}
                                            onChange={() => props.handleAnswerChange(childIndex, answer.id)}
                                        />
                                    })} </div> : null}

                            {question.type === "checkbox" ?
                                <div className='onboarding-single-checks'>
                                    <div key={`default-checkbox`} className="form-checkboxes">
                                        {question.answers.map((answer) => {
                                            return <Form.Check
                                                key={answer.id}
                                                type="checkbox"
                                                id={`question-${question.id}-answer-${answer.id}`}
                                                checked={question.user_answers !== null ? question.user_answers.includes(answer.id) : null}
                                                onChange={() => props.handleCheckboxChange(childIndex, answer.id)}
                                                label={answer.description} />
                                        })}
                                    </div>
                                </div> : null}

                            {question.type === "text" || question.type === "number" ?
                                <Form.Control className='answer-text' onChange={(event) => props.handleAnswerChange(childIndex, event.target.value)} type={question.type} /> : null}

                            {question.type === "time" ?
                                <Time time={question.max_time} label="" user_answers={question.user_answers} handleAnswerChange={(time) => props.handleAnswerChange(childIndex, time)} /> : null}

                            {question.type === "dropdown" ?
                                <div className='alert-time'>
                                    <Form.Group className='question-times' controlId="formGroupHours">
                                        <span className='drop-arrow-2'></span>
                                        <Form.Select aria-label="Default select example" onChange={(event) => props.handleAnswerChange(childIndex, event.target.value)} value={question.user_answers} >
                                            {question.user_answers === null ? <option value={null}></option> : null}
                                            {question.answers.sort((a, b) => a.id - b.id).map((answer) => {
                                                return <option key={answer.id} value={answer.id}>{answer.description}</option>
                                            })}
                                        </Form.Select>
                                    </Form.Group></div> : null}

                            {question.type === "company-list" ?
                                <div className='alert-time'>
                                    <Form.Group className='question-times' controlId="formGroupHours">
                                        <span className='drop-arrow-3'></span>
                                        <Form.Select aria-label="Default select example" name="user_answers" 
                                            disabled
                                            value={question.user_answers} >
                                            {question.user_answers === null ? <option value={null}></option> : null}
                                            {question.answers.sort((a, b) => a.id - b.id).map((answer) => {
                                                return <option key={answer.id} value={answer.id}>{answer.description}</option>
                                            })}
                                        </Form.Select>
                                    </Form.Group></div> : null}
                        </div>
                        {question.user_answers != null && getDivisionQuestions(question) !== null ? <div class="onboarding-single-question">
                            <div className='question-style'>1.1i WHAT ARE THE DIVISIONS OR BUSINESS AREAS WITHIN THE PARTICIPATING ORGANIZATIONS?</div>
                            <div className='alert-time'>
                                <Form.Group className='question-times' controlId="formGroupHours">
                                    <span className='drop-arrow-3'></span>
                                    <Form.Select aria-label="Default select example" value={question.selcted_division} onChange={(event) => props.handleDivisionAnswerChange(childIndex, event.target.value)} >
                                        {question.selcted_division === null ? <option value={null}></option> : null}
                                        {getDivisionQuestions(question).map((division) => {
                                            return <option key={division.id} value={division.id}>{division.name}</option>
                                        })}
                                    </Form.Select>
                                </Form.Group></div>
                        </div> : null}
                    </>
                })
                : null}
        </Fragment>
    )
}
export default Questionnaire;